export default function clearSessionRedirect(): void {
  const REDIRECT_DECISION_COOKIE_NAME = 'zego_myaccount_redirect';
  if (window.sessionStorage.getItem(REDIRECT_DECISION_COOKIE_NAME) !== null) {
    window.sessionStorage.removeItem(REDIRECT_DECISION_COOKIE_NAME);
  }
}
